import type { SalesChecklistItemDefaultExample } from "@expert/contentful";
import { ChecklistExampleDefaultState } from "@/sales-tools/home-product/components/FullOfferChecklist/components/ChecklistExampleDefaultState";
import type { ChecklistItemExample } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/ChecklistItemExampleCarousel";
import { ChecklistItemExampleCarousel } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/ChecklistItemExampleCarousel";

type CarouselWithDefaultParams = {
    examples?: ChecklistItemExample[];
    defaultExample?: SalesChecklistItemDefaultExample;
};

export function CarouselWithDefault({ examples, defaultExample }: CarouselWithDefaultParams) {
    return examples?.length ? (
        <ChecklistItemExampleCarousel examples={examples} />
    ) : (
        <ChecklistExampleDefaultState {...defaultExample} />
    );
}
